import React from "react"
import injectSheet from "react-jss"
import cn from "classnames"

const styles = {
  dotsWrapper: { composes: "flex aic jcc pt32 pb24 posa b0 w100" },
  dot: { composes: "circle bg-gray-10 mx4", width: 8, height: 8 },
  dotActive: { composes: "bg-petrol-link" },
}

const Dot = injectSheet(styles)(({ classes, active }) => (
  <span className={cn(classes.dot, { [classes.dotActive]: active })} />
))

const CarouselDots = ({ classes, total, index }) => (
  <div className={classes.dotsWrapper}>
    {total > 1 &&
      Array.apply(null, Array(total)).map((x, i) => {
        return <Dot key={i} active={index === i} />
      })}
  </div>
)

export default injectSheet(styles)(CarouselDots)
